import React, { useEffect, useState } from 'react';

import {
    Container as MaterialContainer,
    Grid,
    Divider,
} from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import {
    arraytoDictionary,
    getProjectStatusOptions,
} from 'common/utils/helpers';

import * as contactFileActions from '../contactFile/actions';
import * as contactFileSelectors from '../contactFile/selectors';
import createContactModal from '../createContactModal';
import * as createContactModalActions from '../createContactModal/actions';
import createProjectModal from '../createProjectModal';
import * as createProjectModalActions from '../createProjectModal/actions';
import loadAndWindModal from '../loadAndWindModal';
import * as loadAndWindModalActions from '../loadAndWindModal/actions';
import * as projectsActions from '../projects/actions';
import proposals from '../proposals';

import * as actions from './actions';
import HeaderSection from './components/HeaderSection';
import KeyIndicatorsReports from './components/KeyIndicatorsReports';
import ProjectCard from './components/ProjectCard';
import * as selectors from './selectors';

const Container = ({
    contact,
    fetchContact,
    fetchProject,
    handleClickUpdate,
    handleClickUpdateContact,
    isFetchingProject,
    match,
    project,
    redirect,
    reset,
    updateStatus,
}) => {
    const { contactId, projectId } = match.params;
    const [currentStatus, setCurrentStatus] = useState('in_process');

    useEffect(() => {
        fetchProject(projectId);
        return () => reset();
    }, [projectId, fetchProject, reset]);

    useEffect(() => {
        if (contactId) {
            fetchContact(contactId);
        }
    }, [contactId, fetchContact]);

    useEffect(() => {
        if (!isEmpty(project)) setCurrentStatus(project?.status);
    }, [project]);

    const handleClickStatus = (item) => {
        setCurrentStatus(item.value);
        updateStatus(projectId, item.value, () => fetchProject(projectId));
    };

    const statusDictionary = arraytoDictionary(
        getProjectStatusOptions(),
        'value',
    );

    if (isFetchingProject) return null;

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderSection
                contactId={contactId}
                currentStatus={currentStatus}
                handleClickStatus={handleClickStatus}
                project={project}
                redirect={redirect}
                statusDictionary={statusDictionary}
            />
            <Divider sx={{ my: 1 }} />

            <Grid container spacing={2}>
                <Grid
                    size={{ md: 14, xs: 18 }}
                    sx={{ order: { md: 0, xs: 1 } }}
                >
                    <ProjectCard
                        handleClickUpdate={handleClickUpdate}
                        isFetching={isFetchingProject}
                        project={project}
                    />
                    <proposals.Container
                        contactIsArchived={
                            project?.contact?.status_flag === 'archived'
                        }
                        projectId={projectId}
                    />
                </Grid>
                <Grid size={{ md: 4, xs: 18 }} sx={{ order: { md: 1, xs: 0 } }}>
                    <KeyIndicatorsReports
                        contactDetails={contact}
                        handleClickUpdate={handleClickUpdateContact}
                    />
                </Grid>
            </Grid>

            <createProjectModal.Container />

            <createContactModal.Container
                onSuccessSave={() => {
                    fetchContact(contactId);
                }}
                contactId={contactId}
            />

            <loadAndWindModal.Container />
        </MaterialContainer>
    );
};

const mapStateToProps = createStructuredSelector({
    contact: contactFileSelectors.getContactData,
    isFetchingProject: selectors.getIsFetchingProject,
    project: selectors.getProjectData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchContact: (contactId) =>
        dispatch(contactFileActions.fetchContact(contactId)),
    fetchProject: (projectId) => dispatch(actions.fetchProject(projectId)),
    handleClickUpdateContact: (values) =>
        dispatch(createContactModalActions.prepareUpdate(values)),
    handleClickUpdate: (values) =>
        dispatch(createProjectModalActions.prepareUpdate(values)),
    handleClickUpdateLoads: (values) =>
        dispatch(loadAndWindModalActions.prepareUpdate(values)),
    redirect: (link) => dispatch(push(link)),
    reset: () => dispatch(actions.reset()),
    updateStatus: (id, status) =>
        dispatch(projectsActions.updateStatus(id, status)),
});

Container.propTypes = {
    contact: PropTypes.object,
    fetchContact: PropTypes.func,
    fetchProject: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    handleClickUpdateContact: PropTypes.func,
    isFetchingProject: PropTypes.bool,
    match: PropTypes.object,
    project: PropTypes.object,
    redirect: PropTypes.func,
    reset: PropTypes.func,
    updateStatus: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Container));
